import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { usePageSpaceKey } from '@confluence/page-context';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled';
import { useSpaceEnabledContentTypes } from '@confluence/create-blank-fabric-page/entry-points/useSpaceEnabledContentTypes';
import { ConfluencePageSubType } from '@confluence/create-blank-fabric-page/entry-points/CreateBlankPageMutation';
import { buildCreationLink } from '@confluence/create-blank-fabric-page/entry-points/createContentRouteUtils';

export const useCreateDoc = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { push } = useRouteActions();
	const { isLivePagesFeatureEnabled } = useIsLivePagesFeatureEnabled();
	const [spaceKey] = usePageSpaceKey();
	const { isCreateLiveDocEnabled } = useSpaceEnabledContentTypes(spaceKey);

	const createDoc = useCallback(() => {
		const shouldCreateLiveDoc = isLivePagesFeatureEnabled && isCreateLiveDocEnabled;

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'createDoc',
				source: 'popularFeedEmptyState',
				attributes: {
					contentType: shouldCreateLiveDoc ? 'liveDoc' : 'page',
					hasSpaceContext: !!spaceKey,
				},
			},
		}).fire();

		const createUrl = buildCreationLink({
			contentType: 'page',
			subType: shouldCreateLiveDoc ? ConfluencePageSubType.LIVE : undefined,
			spaceKey,
			withFallback: true,
			source: 'popularFeedEmptyState',
		});

		push(createUrl);
	}, [createAnalyticsEvent, push, isLivePagesFeatureEnabled, isCreateLiveDocEnabled, spaceKey]);

	return { createDoc };
};
